import moment from 'moment';

const importsData = {

    namespaced: true,
    state: {
        importsList: []
    },
    mutations: {
        updateImportsList(state, newList) {
            state.importsList = newList;
        },

    },
    actions: {

        getImportFiles(context) {
            this._vm.$traveller_http.get('/traveller/restui/timetables/import-table/list', {
            })
                .then(function (response) {
                    
                    response.data.forEach(item => {
                        item.validFrom = moment(item.validFrom).format('YYYY-MM-DD');
                        item.validUntil = moment(item.validUntil).format('YYYY-MM-DD');
                    });

                    context.commit('updateImportsList', response.data)

                })

        },

    },

}

export default importsData;